export interface AuditLogFieldDetail {
    fieldName: string;
    oldValue: string;
    newValue: string;
}

export interface AuditLogEntityDetail {
    id: number;
    entityName: string;
    primaryKey: number;
    operation: number;
    operationDescription: string;
    isBulkSave: boolean;
    fields: AuditLogFieldDetail[];
}

export interface AuditLogDetailsDto {
    id: number;
    userFullName: string;
    userId: number;
    operation: number;
    entityName: string;
    parsedEntityName: string;
    operationDescription: string;
    date: string;
    correlationId: string;
    primaryKey: number;
    primaryKeyDescription: string;
    isBulkSave: boolean;
    isBulkSaveDescription: string;
    employeeId?: number;
    employeeFullName?: string;
    affectedColumns?: string;
    entities: AuditLogEntityDetail[];
}

export interface FilteredAuditLogsResponse {
    data: AuditLogDetailsDto[];
    filteredRecordsCount: number;
    totalRecordsCount: number;
}

export const AUDITABLE_ENTITY_OPTIONS = [
    { value: 'WorkshiftScheduling', label: 'Programación de turnos' },
    { value: 'Interruption', label: 'Interrupción' },
    { value: 'WorkshiftSchedulingCostCenter', label: 'Programación — centro de costo' },
    { value: 'WorkshiftSchedulingOperationCenter', label: 'Programación — centro de operación' },
] as const;
